<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}
.image_right_flip {
  padding-bottom: 40px;
  transform: rotate(-90deg);
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Self-Medicated Practices</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, self-medication, tools</p>
        <p>
          This publication accompanies the self-medicated practices <a href="https://varia.zone/en/self-medicated-practices-diy.html">research thread</a> in Varia, and is built in two parts.</p>
        <p>
          The first part of this publication deals with the topic of medical devices, and how people make use of them to monitor their vitals or other aspects of their health, treat symptoms,
administer medication or act in an emergency. Alongside information and resources related to
medical devices, the publication also delves into privacy concerns related to the use of
medical and personal data by corporations.</p>
          <p>The publication was developed in collaboration with Yoana Buzova.</p>




      </div>
      </b-col>
      <b-col md="8">
        <b-row class="image_right">
          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/selfmedicated/stack.jpg"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">
          <b-col md="6" offset-md="2">
            <b-img class="img-fluid" src="media/selfmedicated/self_end_small.png"></b-img>
            <b-img class="img-fluid" src="media/selfmedicated/self_inside_small.png"></b-img>

          </b-col>

        
    </b-row>
    
    </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'SelfMedicated',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
